var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodebox2 = function SvgCodebox2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 86,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#codebox_2_svg__a)",
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.5 6.917 34.583 22.479v24.208L42.5 76.084 7.917 53.603V29.396L42.5 6.916Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 7 8 29l34 24 34.5-24L42 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 41 17.5-11L59 41M24 40v23M42 75.48V53M58 65.48V43",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "codebox_2_svg__a",
    x: -4,
    y: 0,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_906_7356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_906_7356",
    result: "shape"
  })))));
};
export default SvgCodebox2;